import React from 'react';
import { ClientApiProps } from '../../common';
import { Assessments } from './Assessments';
import { Callsigns } from './Callsigns';
import { IOperatorAssessment, IOperatorCallsign, IOperatorPayload } from '../../api';

export interface OperatorPageProps extends ClientApiProps {
  callsigns: IOperatorCallsign[];
  assessments: IOperatorAssessment[];
  onChange: (mode: Partial<IOperatorPayload>) => any;
  onSpinner: (msg: string) => any;
  onAuthorisation: () => any;
}

export const OperatorPage: React.FC<OperatorPageProps> = (props) => {
  return (
    <>
      <p>
        You can view complete list of callsigns on{' '}
        <a id="callsign-register-link" href="/call-signs">
          ACMA Call Sign Register
        </a>
        .
      </p>
      <Callsigns {...props} rows={props.callsigns} onAuthorisation={props.onAuthorisation} onChange={props.onChange} />
      <div className="mt-4">
        <Assessments {...props} rows={props.assessments} onSpinner={props.onSpinner} onAuthorisation={props.onAuthorisation} />
      </div>
    </>
  );
};
